var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57575_24758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 0C10.7664 0 0 10.7664 0 24C0 37.2336 10.7664 48 24 48C37.2336 48 48 37.2336 48 24C48 10.7664 37.2336 0 24 0ZM24 44.3077C12.8023 44.3077 3.69234 35.1976 3.69234 24C3.69234 12.8024 12.8023 3.69234 24 3.69234C35.1977 3.69234 44.3077 12.8023 44.3077 24C44.3077 35.1977 35.1977 44.3077 24 44.3077Z",
    fill: "#B80006"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5408 16.541L20.3076 28.774L15.4592 23.9256L12.8485 26.5364L20.3076 33.9957L35.1514 19.1518L32.5408 16.541Z",
    fill: "#B80006"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57575_24758"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckError);
export default __webpack_public_path__ + "static/media/check_error.f27c050116a761add38d67c3d6224e84.svg";
export { ForwardRef as ReactComponent };